import { Component } from 'react';
import { reportClientError } from '../lib/clientErrorReporter';
import type { ReactNode } from 'react';

export class ErrorBoundary extends Component<
  { children: ReactNode; fallback?: ReactNode },
  { hasError: boolean; error?: Error }
> {
  state = { hasError: false };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('App Error:', error, info);
    // CLIENT_ERROR: the "Algo salió mal" screen is user-visible — register it.
    reportClientError({
      message: error?.message || 'ErrorBoundary caught render error',
      level: 'error',
      context: { componentStack: String(info?.componentStack || '').slice(0, 600), route: window.location.pathname },
    });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="min-h-full flex items-center justify-center bg-[var(--v-base-bg)] p-4">
          <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Algo salió mal</h2>
            <p className="text-gray-600 mb-4">Por favor recarga la página o contacta soporte.</p>
            <button 
              onClick={() => window.location.reload()}
              className="bg-[#36CCD8] text-white px-6 py-2 rounded-lg font-semibold hover:bg-[#2DB8C4]"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
